import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import SideBar from "../../SideBar/SideBar";

const Pagination = ({ pageResponce, pagedataToParent }) => {



  const generateValues = (start, end, increment) => {
    const result = [];
    for (let i = start; i <= end; i += increment) {
      result.push(i);
    }
    return result;
  };
  const [values] = useState(generateValues(10, 50, 10));
  const [pagedResponse, setPagedResponse] = useState(null);
  const [pageInfo, setPageInfo] = useState({
    currentPage: 0,
    totalPages: 1,
    pageSize: 10,
  });

  useEffect(() => {
    setPageInfo((prevPageInfo) => ({
      ...prevPageInfo,
      totalPages: pageResponce.totalPages,
    }));
  }, [pageInfo.currentPage]);

  const nextPage = () => {
    if (pageInfo.currentPage < pageInfo.totalPages - 1) {
      setPageInfo((prevPageInfo) => ({
        ...prevPageInfo,
        currentPage: prevPageInfo.currentPage + 1,
      }));
      setPageInfo((prevPageInfo) => {
        pagedataToParent(prevPageInfo);
        return prevPageInfo;
      });
    }
  };
  const previousPage = () => {
    if (pageInfo.currentPage > 0) {
      setPageInfo((prevPageInfo) => ({
        ...prevPageInfo,
        currentPage: prevPageInfo.currentPage - 1,
      }));
      setPageInfo((prevPageInfo) => {
        pagedataToParent(prevPageInfo);
        return prevPageInfo;
      });
    }
  };

  const goToPage = (page) => {
    if (page >= 0 && page < pageInfo.totalPages && page !== pageInfo.currentPage) {
      setPageInfo((prevPageInfo) => ({
        ...prevPageInfo,
        currentPage: page,
      }));
      setPageInfo((prevPageInfo) => {
        pagedataToParent(prevPageInfo);
        return prevPageInfo;
      });
    }
  };

  const getPages = () => {
    const totalPages = pageInfo.totalPages;
    const visiblePages = 5;

    if (totalPages <= visiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      const currentPage = pageInfo.currentPage;
      const pagesToShow = [];

      for (let i = Math.max(1, currentPage - Math.floor(visiblePages / 2) + 1); i <= currentPage; i++) {
        pagesToShow.push(i);
      }

      for (let i = currentPage + 1; i <= Math.min(currentPage + visiblePages - 1, totalPages); i++) {
        if (i !== totalPages) {
          pagesToShow.push(i);
        }
      }

      if (pagesToShow[pagesToShow.length - 1] < totalPages - 1) {
        pagesToShow.push('...');
      }

      pagesToShow.push(totalPages);

      return pagesToShow;
    }
  };



  const onValueChange = () => {
    console.log("pageSize: " + pageInfo.pageSize);
  };



  return (
    <>
      <div>
        {/* Header */}
        {/* <Header /> */}

        {/* Sidebar */}
        {/* <SideBar /> */}

        {/* Page Wrapper */}

        <div class="page-wrapper">
          <div class="content container-fluid">
            {/* Page Header */}
            {/* <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Pagination</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Components</li>
                  </ul>
                </div>
              </div>
            </div> */}
            {/* Pagination */}
            <section className="comp-section" id="comp_pagination">
              {/* <h3 className="section-title">Pagination</h3> */}
              <div className="pagination-box">
                {/* <div>
                  <ul className="pagination">
                    <li className="page-item disabled">
                      <Link className="page-link" to="#" tabIndex={-1}>
                        Previous
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        1
                      </Link>
                    </li>
                    <li className="page-item active">
                      <Link className="page-link" to="#">
                        2 <span className="sr-only">(current)</span>
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        3
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        Next
                      </Link>
                    </li>
                  </ul>
                </div> */}
                <div>
                  <ul className="pagination">
                    <li className="page-item" onClick={() => previousPage()}>
                      <Link className="page-link" to="#" aria-label="Previous">
                        <span aria-hidden="true">«</span>
                        <span className="sr-only">Previous</span>
                      </Link>
                    </li>
                    {getPages().map((page) => (
                      <li key={page} className={`page-item ${page - 1 === pageInfo.currentPage ? 'active' : ''}`}>
                        <Link className="page-link" to="#" onClick={() => goToPage(page - 1)}>
                          {page}
                        </Link>
                      </li>
                    ))}

                    {/* <li className="page-item">
                      <Link className="page-link" to="#">
                        2
                      </Link>
                    </li> */}
                    {/* <li className="page-item">
                      <Link className="page-link" to="#">
                        3 nextPage
                      </Link>
                    </li> */}
                    <li className="page-item" onClick={() => nextPage()}>
                      <Link className="page-link" to="#" aria-label="Next">
                        <span aria-hidden="true">»</span>
                        <span className="sr-only">Next</span>
                      </Link>
                    </li>
                  </ul>
                </div>
                {/* <div>
                  <ul className="pagination pagination-lg">
                    <li className="page-item disabled">
                      <Link className="page-link" to="#" tabIndex={-1}>
                        Previous
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        1
                      </Link>
                    </li>
                    <li className="page-item active">
                      <Link className="page-link" to="#">
                        2 <span className="sr-only">(current)</span>
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        3
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        Next
                      </Link>
                    </li>
                  </ul>
                </div> */}
                {/* <div>
                  <ul className="pagination pagination-sm">
                    <li className="page-item disabled">
                      <Link className="page-link" to="#" tabIndex={-1}>
                        Previous
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        1
                      </Link>
                    </li>
                    <li className="page-item active">
                      <Link className="page-link" to="#">
                        2 <span className="sr-only">(current)</span>
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        3
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        Next
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
            </section>
            {/* /Pagination */}
          </div>
        </div>

        {/* /Page Wrapper */}
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default Pagination;
